(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-details"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    const headers = document.querySelectorAll(".collapsible-tabs h2");
    headers[0].classList.add("active");

    headers.forEach((header) => {
      const content = header.nextElementSibling;

      if (!header.textContent) {
        header.classList.add('hidden');
        content.classList.add('hidden');
      }

      if (!content || !content.classList.contains("content-tab")) return;

      header.addEventListener("click", () => {
        const isOpen = header.classList.contains("active");

        headers.forEach((header) => {
          header.classList.remove("active");
        });

        if (!isOpen) {
          header.classList.add("active");
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
